interface VisitWebhookPayload {
    title: string;
    start: string;
    end: string;
    visitPurpose: string;
    location: string;
    companyName: string;      // NUEVO
    city: string;             // NUEVO
    branch: string;           // NUEVO
    userEmail: string;        // NUEVO
    collaboratorsEmails: string[];
}


const formatForN8n = (isoDate: string): string => {
    const date = new Date(isoDate);

    // Formatear en UTC manteniendo la Z
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const seconds = String(date.getUTCSeconds()).padStart(2, '0');

    // Retornar con Z al final para que SharePoint lo interprete como UTC
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;
};


export const sendVisitToN8n = async (
    visitPurpose: string,
    startDateTime: string,
    endDateTime: string,
    companyName: string,      // NUEVO
    city: string,             // NUEVO
    branch: string,           // NUEVO
    userEmail: string,        // NUEVO
    collaboratorsEmails: string[], // 👈 nuevo

): Promise<{ success: boolean; error?: string }> => {
    const N8N_WEBHOOK_URL = import.meta.env.VITE_N8N_WEBHOOK_CREATE_CALENDAR_EVENT_URL;

    if (!N8N_WEBHOOK_URL) {
        return { success: false, error: 'Webhook URL no configurada' };
    }

    try {
        const payload: VisitWebhookPayload = {
            title: `Visita: ${visitPurpose}`,
            start: formatForN8n(startDateTime),
            end: formatForN8n(endDateTime),
            visitPurpose,
            location: `${companyName} - ${branch || 'Matriz'}, ${city}`,  // Formato completo
            companyName,
            city,
            branch: branch || 'Matriz',
            userEmail,
            collaboratorsEmails 
        };

        const response = await fetch(N8N_WEBHOOK_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            const errorText = await response.text();
            console.error(' Error n8n:', response.status, errorText);
            return { success: false, error: `HTTP ${response.status}` };
        }

        return { success: true };

    } catch (error) {
        console.error('Error enviando a n8n:', error);
        return {
            success: false,
            error: error instanceof Error ? error.message : 'Error desconocido'
        };
    }
};
